import React from 'react';
import { Route, Routes as RoutesWrapper, Outlet } from 'react-router-dom';
import { AuthContextProvider } from 'src/context/auth.context';
import { DeviceContextProvider } from 'src/context/device.context';
import { PageContextProvider } from 'src/context/page.context';
import NotFound from 'src/pages/not-found';
import AuthCallback from 'src/pages/auth-callback';
import OTPList from 'src/pages/manage-otps/list';
import MyOrganisation from 'src/pages/my-organisation';
import DashboardPage from 'src/pages/dashboard';
import RestaurantList from 'src/pages/manage-restaurants/list';
import Layout from '../layout';
import { Routes } from './constants';
import RestaurantPage from 'src/pages/manage-restaurants/item';
import UserOTPPage from 'src/pages/manage-otps/user';
import { LogInRuleFormPage } from 'src/pages/admin/login-rules/form';
import { LogInRuleFormEditPage } from 'src/pages/admin/login-rules/edit';
import ManageQuestions from 'src/pages/wttp/questions/list';
import WttpTemplateListPage from 'src/pages/wttp/templates/list';
import WttpQuestionnairesListPage from 'src/pages/wttp/questionaires/list';
import { QuestionnaireResponseList } from 'src/pages/wttp/questionnaire-responses/list';
import { IssueTicketListPage } from 'src/pages/issue/issue-tickets/list';
import { WttpConfigurationPage } from 'src/pages/wttp/configuration/configuration';
import { AdminPage } from 'src/pages/admin/admin';
import { CustomThemeProvider, SnackbarProvider } from '@otp/ui';
import { TranslationContextProvider } from 'src/context/i18n.context';
import { NotificationPreferencesPage } from 'src/pages/notification/preferences';
import { MostPage } from 'src/pages/most/list';
import { DayjsDateTimeLocalizationProvider } from '@otp/ui';
import PermissionListPage from 'src/pages/admin/permissions/list';
import RoleListPage from 'src/pages/admin/roles/list';
import RoleFormPage from 'src/pages/admin/roles/form';
import { UserGroupListPage } from 'src/pages/admin/user-group/list';
import { UserGroupItemPage } from 'src/pages/admin/user-group/item';
import { LoginRuleListPage } from 'src/pages/admin/login-rules/list';
import { ToolsPage } from 'src/pages/tools/tools';
import { NotificationPage } from 'src/pages/notification/list';
import AuthorizationContextProvider from 'src/context/authorization.context';
import { LmsCurriculumListAdminPage } from 'src/pages/admin/lms/curriculums/lms';
import { UserProfilePage } from 'src/pages/profile/user';
import { EditUserProfilePage } from 'src/pages/profile/edit-user';
import { LmsCurriculumFormPage } from 'src/pages/admin/lms/curriculums/edit';
import { LmsCertificateListPage } from 'src/pages/admin/lms/certificates/lms-certificates';
import { LmsCurriculumListPage } from 'src/pages/lms/curriculums';
import { UserMergeRequestListPage } from 'src/pages/admin/user-merge-requests/list';
import { UserMergeRequestItemPage } from 'src/pages/admin/user-merge-requests/item';
import { ProfileUserMergeRequestItemPage } from 'src/pages/profile/user-mergre-request';
import { FieldOfficeCountOtpReportPage } from 'src/pages/reporting/field-office/count-otp-report-list';
import ResourceFormPage from 'src/pages/admin/resource/form';
import { ResourceListPage } from 'src/pages/admin/resource/list';
import { UserResourceListPage } from 'src/pages/resource/list';
import { SearchListPage } from 'src/pages/search/list';
import { UserResourceDetailsPage } from 'src/pages/resource/details';
import { ReportsPage } from 'src/pages/reports/reports';
import { ErrorProvider } from 'src/context/error.context';

function Router() {
  return (
    <RoutesWrapper>
      <Route
        path={Routes.home.path}
        element={
          <CustomThemeProvider>
            <TranslationContextProvider>
              <DayjsDateTimeLocalizationProvider>
                <PageContextProvider>
                  <DeviceContextProvider>
                    <AuthContextProvider>
                      <AuthorizationContextProvider>
                        <SnackbarProvider>
                          <ErrorProvider>
                            <Layout>
                              <Outlet />
                            </Layout>
                          </ErrorProvider>
                        </SnackbarProvider>
                      </AuthorizationContextProvider>
                    </AuthContextProvider>
                  </DeviceContextProvider>
                </PageContextProvider>
              </DayjsDateTimeLocalizationProvider>
            </TranslationContextProvider>
          </CustomThemeProvider>
        }
      >
        <Route index element={<MyOrganisation />} />
        <Route path={Routes.admin.path} element={<AdminPage />} />
        <Route path={Routes.dashboard.path} element={<DashboardPage />} />
        <Route path={Routes.users.path} element={<OTPList />} />
        <Route path={`${Routes.users.path}/:id`} element={<UserOTPPage />} />
        <Route path={Routes.profile.path} element={<UserProfilePage />} />
        <Route
          path={Routes.editProfile.path}
          element={<EditUserProfilePage />}
        />
        <Route
          path={Routes.editUserProfile.path}
          element={<EditUserProfilePage />}
        />
        <Route
          path={Routes.profileUserMergeRequest.path}
          element={<ProfileUserMergeRequestItemPage />}
        />
        <Route path={Routes.myOrganisation.path} element={<MyOrganisation />} />
        <Route path={Routes.restaurants.path} element={<RestaurantList />} />
        <Route
          path={`${Routes.restaurants.path}/:id`}
          element={<RestaurantPage />}
        />
        <Route path={Routes.loginRules.path} element={<LoginRuleListPage />} />
        <Route
          path={Routes.loginRuleCreate.path}
          element={<LogInRuleFormPage />}
        />
        <Route
          path={`${Routes.loginRules.path}/:id`}
          element={<LogInRuleFormEditPage />}
        />
        <Route path={Routes.wttpQuestions.path} element={<ManageQuestions />} />
        <Route
          path={Routes.wttpTemplates.path}
          element={<WttpTemplateListPage />}
        />
        <Route
          path={Routes.wttpQuestionnaires.path}
          element={<WttpQuestionnairesListPage />}
        />
        <Route
          path={Routes.wttpQuestionnaireResponses.path}
          element={<QuestionnaireResponseList />}
        />
        <Route
          path={Routes.wttpConfiguration.path}
          element={<WttpConfigurationPage />}
        />
        <Route
          path={Routes.issueTickets.path}
          element={<IssueTicketListPage />}
        />
        <Route path={Routes.mostBase.path} element={<MostPage />} />
        <Route
          path={Routes.notificationList.path}
          element={<NotificationPage />}
        />
        <Route
          path={Routes.notificationPreferences.path}
          element={<NotificationPreferencesPage />}
        />
        <Route
          path={Routes.lmsCurriculums.path}
          element={<LmsCurriculumListPage />}
        />
        <Route
          path={Routes.permissions.path}
          element={<PermissionListPage />}
        />
        <Route path={Routes.roles.path} element={<RoleListPage />} />
        <Route path={Routes.userGroups.path} element={<UserGroupListPage />} />
        <Route
          path={`${Routes.userGroups.path}/:id`}
          element={<UserGroupItemPage />}
        />
        <Route path={`${Routes.roles.path}/new`} element={<RoleFormPage />} />
        <Route path={`${Routes.roles.path}/:id`} element={<RoleFormPage />} />
        <Route path={Routes.tools.path} element={<ToolsPage />} />
        <Route
          path={Routes.lmsCurriculumsAdmin.path}
          element={<LmsCurriculumListAdminPage />}
        />
        <Route
          path={Routes.lmsCurriculumCreate.path}
          element={<LmsCurriculumFormPage />}
        />
        <Route
          path={`${Routes.lmsCurriculumsAdmin.path}/:id`}
          element={<LmsCurriculumFormPage />}
        />
        <Route
          path={Routes.lmsCertificates.path}
          element={<LmsCertificateListPage />}
        />
        <Route
          path={Routes.userMergeRequestsCreate.path}
          element={<UserMergeRequestItemPage />}
        />
        <Route
          path={`${Routes.userMergeRequests.path}/:id`}
          element={<UserMergeRequestItemPage />}
        />
        <Route
          path={`${Routes.userMergeRequests.path}`}
          element={<UserMergeRequestListPage />}
        />
        <Route
          path={Routes.fieldOfficeCountOtpReport.path}
          element={<FieldOfficeCountOtpReportPage />}
        />
        <Route
          path={`${Routes.adminResources.path}`}
          element={<ResourceListPage />}
        />
        <Route
          path={`${Routes.adminResourcesCreate.path}`}
          element={<ResourceFormPage />}
        />
        <Route
          path={`${Routes.adminResourcesUpdate.path}`}
          element={<ResourceFormPage />}
        />
        <Route
          path={Routes.resources.path}
          element={<UserResourceListPage />}
        />
        <Route path={Routes.search.path} element={<SearchListPage />} />
        <Route
          path={`${Routes.resources.path}/:id`}
          element={<UserResourceDetailsPage />}
        />
        <Route path={Routes.reports.path} element={<ReportsPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path={Routes.authCallback.path} element={<AuthCallback />} />
    </RoutesWrapper>
  );
}

export default Router;
